import REDUX_ASSOCIATION_NON_DELETABLE from '../../constants/association-non-deletable'
import REDUX_NON_DELETABLE from '../../constants/non-deletable'
import getAssociationKeysReduxUtil from '../get-associations-keys'
import getClassNameReduxUtil from '../get-class-name'
import getInstanceReduxUtil from '../get-instance'
import { getPathReduxUtil } from '../get-path'
import { getValueReduxUtil } from '../get-value'
import deletePathReferenceUtil from '../../../references/utils/delete-path'
import setUtil from '../../../../utils/set'

/**
 * Deletes the instance and its associations by:
 * - Removing them from the domain map
 * @param  {Object} state
 * @param  {Object} instance
 * @return {Object}
 */
function deleteInstanceReduxUtil (state, instance) {
  if (!instance) {
    return state
  }
  if (REDUX_NON_DELETABLE.includes(getClassNameReduxUtil(instance))) {
    return state
  }
  const path = getPathReduxUtil(instance)
  const associationKeys = getAssociationKeysReduxUtil(instance)
  if (associationKeys && associationKeys.length) {
    state = associationKeys.reduce((updatedState, associationKey) => {
      const associationNonDeletable = REDUX_ASSOCIATION_NON_DELETABLE[getClassNameReduxUtil(
        instance)]
      if (Array.isArray(associationNonDeletable) &&
        associationNonDeletable.includes(associationKey)) {
        return updatedState
      }

      const associationPointer = getValueReduxUtil(instance, associationKey)
      if (!associationPointer) {
        return updatedState
      }

      if (Array.isArray(associationPointer)) {
        return associationPointer.reduce((newUpdatedState, assoc) => {
          if (!assoc) {
            return newUpdatedState
          }
          const association = getInstanceReduxUtil(state, assoc)
          if (!association ||
            REDUX_NON_DELETABLE.includes(getClassNameReduxUtil(association))) {
            return newUpdatedState
          }
          return deleteInstanceReduxUtil(newUpdatedState, association)
        }, updatedState)
      }

      const association = getInstanceReduxUtil(state, associationPointer)
      if (!association ||
        REDUX_NON_DELETABLE.includes(getClassNameReduxUtil(association))) {
        return updatedState
      }

      return deleteInstanceReduxUtil(updatedState, association)
    }, state)
  }
  // Delete the path from the references
  state = deletePathReferenceUtil({
    state,
    instance
  })
  return setUtil(state, path)
}

export { deleteInstanceReduxUtil }
